import { TableRowType } from 'SharedDir/declarations/fields';

export default class TableRow {
  label!: string;

  slug!: string;

  order: number = 0;

  isSummary!: boolean;

  constructor({ label, slug, order, isSummary }: Partial<TableRowType> = {}) {
    this.label = label || '';
    this.slug = slug || '';
    if (order) {
      this.order = order;
    }
    this.isSummary = isSummary || false;
  }
}
